import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3.5 sm:p-4 rounded-xl border-2 border-gold/40 bg-[#FFFDF9] hover:border-active hover:shadow-md transition-all cursor-pointer flex flex-col justify-between relative overflow-hidden group" }
const _hoisted_2 = { class: "absolute top-0 right-0 px-2 py-0.5 text-[10px] font-bold rounded-bl bg-gold text-white" }
const _hoisted_3 = { class: "text-xs text-muted font-medium" }
const _hoisted_4 = { class: "flex items-baseline gap-2 mt-1" }
const _hoisted_5 = { class: "text-xl sm:text-2xl font-bold text-brown font-caudex" }
const _hoisted_6 = { class: "text-xs font-semibold text-active" }
const _hoisted_7 = { class: "mt-2 space-y-1" }
const _hoisted_8 = { class: "text-[11px] font-bold text-success flex items-center gap-1" }
const _hoisted_9 = {
  key: 0,
  class: "text-[11px] text-[#9A6E1E] bg-[#FFF6E4] px-2 py-0.5 rounded font-medium truncate"
}
const _hoisted_10 = { class: "mt-3 pt-2 border-t border-divider/80" }
const _hoisted_11 = {
  key: 0,
  class: "text-[11px] text-brown font-medium truncate"
}
const _hoisted_12 = { class: "text-[11px] text-active font-bold mt-1.5 flex items-center justify-between group-hover:translate-x-0.5 transition-transform" }

import { computed } from "vue";
import { MonthDayReport } from "@/types/calculators";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'TopDayCard',
  props: {
    dayReport: {},
    dayIndex: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const weekOfDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const starStructureDesc = computed(() => {
  if (props.dayReport.personal_status.structures.length > 0) {
    return props.dayReport.personal_status.structures[0];
  }
  if (props.dayReport.personal_status.stars.length > 0) {
    return props.dayReport.personal_status.stars[0];
  }
  return null;
});
const yiDesc = computed(() => {
  if (props.dayReport.yi_preview.length > 0) {
    return `宜: ${props.dayReport.yi_preview[0].name} (${props.dayReport.yi_preview[0].ua})`;
  }
  return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " #" + _toDisplayString(__props.dayIndex + 1) + " • " + _toDisplayString(__props.dayReport.combined_index) + "% ", 1),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.dayReport.date.split("-").reverse().join(".")) + " (" + _toDisplayString(_unref(t)(`week-names.${weekOfDays[__props.dayReport.day_of_week_num - 1]}`)) + ") ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.dayReport.pillars.day), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.dayReport.officer_12.name) + " (" + _toDisplayString(__props.dayReport.officer_12.title_ua) + ") ", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, " ✓ " + _toDisplayString(_unref(t)("calculators.personal-date.top-days.rang")) + " " + _toDisplayString(__props.dayReport.general_status.rank_code), 1),
          _createElementVNode("span", null, " • " + _toDisplayString(_unref(t)("calculators.personal-date.top-days.bazi")) + " " + _toDisplayString(__props.dayReport.personal_status.score) + "% ", 1)
        ]),
        (starStructureDesc.value !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(starStructureDesc.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (yiDesc.value !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(yiDesc.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.top-days.full-report")), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "→", -1))
      ])
    ])
  ]))
}
}

})